import React, { useEffect, useState, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Breadcrumb from "../../components/Breadcrumb";
import RightArrow from "../../components/SVG";
import SingleProgress from "../../components/Progress";
import Logo from "../../assets/img/logo/logo-black.png";
import Men from "../../assets/img/men.jpg";
import defualt from "../../assets/img/admin/defualt.png";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { deleteImage, uploadImages } from "../../services/uploaderServices";
import { updateMember } from "../../services/memberServices";
import { X } from "lucide-react";
import { useAuth } from "../../context/AdminAuthContext";
import toast from "react-hot-toast";
import ChangePasswordTabPanel from "./ChangePasswordTabPanel ";
import NewsFormPopup from "./NewsFormPopup";
import { NewsCardGrid } from "./NewsGridCard";
import SingleBlog from "../../components/Blog";
import Cookies from "js-cookie";

const getSocialIcon = (url) => {
  if (!url) return "fa-regular fa-globe";
  if (url.includes("facebook.com")) return "fab fa-facebook";
  if (url.includes("twitter.com")) return "fab fa-twitter";
  if (url.includes("linkedin.com")) return "fab fa-linkedin";
  if (url.includes("instagram.com")) return "fab fa-instagram";
  return "fa-regular fa-globe";
};

const formatDate = (dateString) => {
  if (!dateString) return "NA";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "NA";
  return date
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
    .replace(/\//g, "-");
};

const MemberProfileMain = ({ member, leadershipRole, memberNews, refetch }) => {
  const cardRef = useRef();
  const { logout } = useAuth();

  const rolesData =
    leadershipRole?.roles?.map((role, index) => {
      let roleName = role.designationId?.name || "";

      return {
        sno: index + 1,
        role: roleName,
        period: `${role.from}–${role.to}`,
      };
    }) || [];

  const initialFormData = {
    profileInfo: {
      title: "Mr.",
      firstName: "",
      middleName: "",
      lastName: "",
      dob: "",
      gender: "Male",
      photo: "",
    },
    communication: {
      email: "",
      telephone: "",
      whatsapp: "",
      mobile: "",
      address: "",
      city: "",
      zipcode: "",
      country: "IN",
      socialLinks: ["", "", ""],
    },
    organization: {
      organizationName: "",
      organizationType: "Private Enterprise",
      organizationAddress: "",
      organizationPhone: "",
      organizationEmail: "",
      aboutCompany: "",
      companyLogo: "",
    },
    workExperience: {
      experienceYears: 0,
      experienceMonths: 0,
    },
    interests: {
      speciesOfInterest: [],
      speciesOther: "",
      fieldOfWork: [],
      fieldOther: "",
      natureOfWork: [],
      natureOther: "",
    },
    educationDetails: "",
    membershipId: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [fileOne, setFileOne] = useState("No file chosen");
  const [fileTwo, setFileTwo] = useState("No file chosen");
  const fileOneRef = useRef(null);
  const fileTwoRef = useRef(null);

  useEffect(() => {
    if (member) {
      const predefinedSpecies = [
        "Shrimp",
        "Warm Water Freshwater Fish",
        "Coldwater Fish",
        "Marine Fish",
      ];
      const predefinedFieldOfWork = [
        "Hatchery Sector",
        "Farm Sector",
        "Healthcare Sector",
        "Feed Sector",
        "Machinery Sector",
        "Government Sector",
        "Processing Sector",
        "Fish Farming & Allied Sector",
        "Markets, Certifications, Policy",
        "Media",
      ];
      const predefinedNatureOfWork = [
        "Teaching",
        "Research",
        "Production",
        "Management",
        "Policy",
      ];

      const customSpecies =
        member.interests?.speciesOfInterest?.filter(
          (item) => !predefinedSpecies.includes(item) && item !== "Others"
        ) || [];

      const customFieldOfWork =
        member.interests?.fieldOfWork?.filter(
          (item) => !predefinedFieldOfWork.includes(item) && item !== "Others"
        ) || [];

      const customNatureOfWork =
        member.interests?.natureOfWork?.filter(
          (item) => !predefinedNatureOfWork.includes(item) && item !== "Others"
        ) || [];

      setFormData({
        profileInfo: {
          title: member.profileInfo?.title || "NA",
          firstName: member.profileInfo?.firstName || "NA",
          middleName: member.profileInfo?.middleName || "NA",
          lastName: member.profileInfo?.lastName || "NA",
          dob: member.profileInfo?.dob
            ? new Date(member.profileInfo.dob).toISOString().split("T")[0]
            : "NA",
          gender: member.profileInfo?.gender || "NA",
          photo: member.profileInfo?.photo || "NA",
        },
        communication: {
          email: member.communication?.email || "NA",
          telephone: member.communication?.telephone || "NA",
          whatsapp: member.communication?.whatsapp || "NA",
          mobile: member.communication?.mobile || "NA",
          address: member.communication?.address || "NA",
          city: member.communication?.city || "NA",
          zipcode: member.communication?.zipcode || "NA",
          country: member.communication?.country || "NA",
          socialLinks: [
            member.communication?.socialLinks?.[0] || "NA",
            member.communication?.socialLinks?.[1] || "NA",
            member.communication?.socialLinks?.[2] || "NA",
          ],
        },
        organization: {
          organizationName: member.organization?.organizationName || "NA",
          organizationType: member.organization?.organizationType || "NA",
          organizationAddress: member.organization?.organizationAddress || "NA",
          organizationPhone: member.organization?.organizationPhone || "NA",
          organizationEmail: member.organization?.organizationEmail || "NA",
          aboutCompany: member.organization?.aboutCompany || "NA",
          companyLogo: member.organization?.companyLogo || "NA",
        },
        workExperience: {
          experienceYears: member.workExperience?.experienceYears || 0,
          experienceMonths: member.workExperience?.experienceMonths || 0,
        },
        interests: {
          speciesOfInterest: [
            ...(member.interests?.speciesOfInterest?.filter((item) =>
              predefinedSpecies.includes(item)
            ) || []),
            ...(customSpecies.length > 0 ? ["Others"] : []),
          ],
          speciesOther: customSpecies.join(", ") || "",

          fieldOfWork: [
            ...(member.interests?.fieldOfWork?.filter((item) =>
              predefinedFieldOfWork.includes(item)
            ) || []),
            ...(customFieldOfWork.length > 0 ? ["Others"] : []),
          ],
          fieldOther: customFieldOfWork.join(", ") || "",

          natureOfWork: [
            ...(member.interests?.natureOfWork?.filter((item) =>
              predefinedNatureOfWork.includes(item)
            ) || []),
            ...(customNatureOfWork.length > 0 ? ["Others"] : []),
          ],
          natureOther: customNatureOfWork.join(", ") || "",
        },
        educationDetails: member.educationDetails || "NA",
        membershipId: member.membershipId || "", // ✅ NEW
      });

      if (member.profileInfo?.photo) setFileOne("Uploaded");
      if (member.organization?.companyLogo) setFileTwo("Uploaded");
    }
  }, [member]);

  const buildSocialUrl = (memberId, socialPlatform) => {
    if (!memberId || !socialPlatform || socialPlatform === "N/A") {
      return "N/A";
    }

    const baseUrl =
      "https://societyofaquacultureprofessionals.org/admin/members/detail";
    return `${baseUrl}/${memberId}/${socialPlatform}`;
  };

  const getSocialDomain = (socialPlatform) => {
    if (!socialPlatform || socialPlatform === "N/A") return "N/A";

    if (socialPlatform.includes(".com") || socialPlatform.includes(".")) {
      return socialPlatform;
    }

    const domainMap = {
      Instagram: "instagram.com",
      Facebook: "facebook.com",
      LinkedIn: "linkedin.com",
      Twitter: "twitter.com",
      X: "x.com",
    };

    return domainMap[socialPlatform] || socialPlatform;
  };

  const personalinformation = [
    { icon: "fa-regular fa-user", content: formData.profileInfo.gender },
    {
      icon: "fa-regular fa-calendar",
      content: formatDate(formData.profileInfo.dob),
    },
    { icon: "fa-regular fa-mobile", content: formData.communication.mobile },
    { icon: "fab fa-whatsapp", content: formData.communication.whatsapp },
    {
      icon: "fa-regular fa-phone-alt",
      content: formData.communication.telephone || "N/A",
    },
    { icon: "fa-regular fa-envelope", content: formData.communication.email },
    {
      icon: "fa-regular fa-map-marker-alt",
      content: formData.communication.address,
    },
    {
      icon: getSocialIcon(formData.communication.socialLinks[0]),
      content: getSocialDomain(formData.communication.socialLinks[0]),
      link: buildSocialUrl(member?._id, formData.communication.socialLinks[0]),
    },
    {
      icon: getSocialIcon(formData.communication.socialLinks[1]),
      content: getSocialDomain(formData.communication.socialLinks[1]),
      link: buildSocialUrl(member?._id, formData.communication.socialLinks[1]),
    },
    {
      icon: getSocialIcon(formData.communication.socialLinks[2]),
      content: getSocialDomain(formData.communication.socialLinks[2]),
      link: buildSocialUrl(member?._id, formData.communication.socialLinks[2]),
    },
  ];

  const organizationInfo = [
    { label: "Name", content: formData.organization.organizationName },
    { label: "Type", content: formData.organization.organizationType },
    { label: "Address", content: formData.organization.organizationAddress },
    { label: "Phone", content: formData.organization.organizationPhone },
    { label: "Email", content: formData.organization.organizationEmail },
    { label: "About Company", content: formData.organization.aboutCompany },
  ];

  const getCleanInterestsForDisplay = () => {
    const cleanedInterests = {
      speciesOfInterest: [
        ...formData.interests.speciesOfInterest.filter(
          (item) => item !== "Others"
        ),
        ...(formData.interests.speciesOther
          ? formData.interests.speciesOther
              .split(", ")
              .filter((item) => item.trim())
          : []),
      ],
      fieldOfWork: [
        ...formData.interests.fieldOfWork.filter((item) => item !== "Others"),
        ...(formData.interests.fieldOther
          ? formData.interests.fieldOther
              .split(", ")
              .filter((item) => item.trim())
          : []),
      ],
      natureOfWork: [
        ...formData.interests.natureOfWork.filter((item) => item !== "Others"),
        ...(formData.interests.natureOther
          ? formData.interests.natureOther
              .split(", ")
              .filter((item) => item.trim())
          : []),
      ],
    };
    return cleanedInterests;
  };

  const cleanedInterests = getCleanInterestsForDisplay();

  const educationinformationareaofinteres = [
    {
      speciesOfInterest: cleanedInterests.speciesOfInterest,
      fieldOfWork: cleanedInterests.fieldOfWork,
      natureOfWork: cleanedInterests.natureOfWork,
      educationDetails: formData.educationDetails,
      experience: formData.workExperience.experienceYears?.toString() || "0",
    },
  ];

  const half = Math.ceil(personalinformation.length / 2);
  const firstHalf = personalinformation.slice(0, half);
  const secondHalf = personalinformation.slice(half);

  const downloadPDF = () => {
    const input = cardRef.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "JPG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("ID-Card.pdf");
    });
  };

  const downloadImage = () => {
    const input = cardRef.current;
    console.log("input", input);

    setTimeout(() => {
      html2canvas(input, {
        scale: 3, // higher resolution
        useCORS: true, // allow external images like logos
        logging: false,
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: document.documentElement.offsetHeight,
        scrollX: 0,
        scrollY: 0,
      }).then((canvas) => {
        const link = document.createElement("a");
        link.download = "ID-Card.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
      });
    }, 300); // wait 300ms for render completion
  };

  const style = {
    width: "100%",
    height: "58px",
    padding: "0px 20px",
    border: "1px solid rgb(0, 0, 0)",
    borderRadius: "10px",
    appearance: "none",
    backgroundColor: "white",
    fontSize: "14px",
    fontWeight: 100,
    color: "#4d5756",
    backgroundImage:
      "url(\"data:image/svg+xml;charset=UTF-8,%3Csvg viewBox='0 0 140 140' width='14' height='14' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%4d5756' d='M70 95L25 50h90z'/%3E%3C/svg%3E\")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 1rem center",
    backgroundSize: "14px",
    outline: "none",
  };

  const optionStyle = {
    fontSize: "14px",
    color: "#4d5756",
    backgroundColor: "white",
    padding: "10px",
    fontWeight: 100,
  };

  const fullName = `${formData.profileInfo.title} ${
    formData.profileInfo.firstName
  } ${
    formData.profileInfo.middleName === "NA"
      ? ""
      : formData.profileInfo.middleName
  } ${formData.profileInfo.lastName}`;

  const handleFileOneChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setFileOne("Uploading...");
    try {
      const formDataUpload = new FormData();
      formDataUpload.append("images", file);
      const response = await uploadImages(formDataUpload);
      const imageUrl = response.images[0].imageUrl;
      setFileOne(file.name);
      setFormData((prev) => ({
        ...prev,
        profileInfo: { ...prev.profileInfo, photo: imageUrl },
      }));
      await updateMember(member._id, {
        ...formData,
        profileInfo: {
          ...formData.profileInfo,
          photo: imageUrl,
        },
      });
    } catch (error) {
      console.error("Error uploading photo:", error);
      setFileOne("Upload failed");
    } finally {
      if (fileOneRef.current) fileOneRef.current.value = "";
    }
  };

  const handleDeletePhoto = async () => {
    try {
      if (formData.profileInfo.photo) {
        await deleteImage(formData.profileInfo.photo);
      }
      setFileOne("No file chosen");
      setFormData((prev) => ({
        ...prev,
        profileInfo: { ...prev.profileInfo, photo: "" },
      }));
      await updateMember(member._id, {
        ...formData,
        profileInfo: {
          ...formData.profileInfo,
          photo: "",
        },
      });
      toast.success("Profile Photo Deleted Successfully");
    } catch (error) {
      console.error("Error deleting photo:", error);
    } finally {
      if (fileOneRef.current) fileOneRef.current.value = "";
    }
  };

  const handleFileTwoChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setFileTwo("Uploading...");
    try {
      const formDataUpload = new FormData();
      formDataUpload.append("images", file);
      const response = await uploadImages(formDataUpload);
      const imageUrl = response.images[0].imageUrl;
      setFileTwo(file.name);
      setFormData((prev) => ({
        ...prev,
        organization: { ...prev.organization, companyLogo: imageUrl },
      }));
    } catch (error) {
      console.error("Error uploading logo:", error);
      setFileTwo("Upload failed");
    } finally {
      if (fileTwoRef.current) fileTwoRef.current.value = "";
    }
  };

  const handleDeleteLogo = async () => {
    try {
      if (formData.organization.companyLogo) {
        await deleteImage(formData.organization.companyLogo);
      }
      setFileTwo("No file chosen");
      setFormData((prev) => ({
        ...prev,
        organization: { ...prev.organization, companyLogo: "" },
      }));
    } catch (error) {
      console.error("Error deleting logo:", error);
    } finally {
      if (fileTwoRef.current) fileTwoRef.current.value = "";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const cleanedInterests = {
        speciesOfInterest: [
          ...formData.interests.speciesOfInterest.filter(
            (item) => item !== "Others"
          ),
          ...(formData.interests.speciesOther
            ? formData.interests.speciesOther
                .split(", ")
                .filter((item) => item.trim())
            : []),
        ],
        fieldOfWork: [
          ...formData.interests.fieldOfWork.filter((item) => item !== "Others"),
          ...(formData.interests.fieldOther
            ? formData.interests.fieldOther
                .split(", ")
                .filter((item) => item.trim())
            : []),
        ],
        natureOfWork: [
          ...formData.interests.natureOfWork.filter(
            (item) => item !== "Others"
          ),
          ...(formData.interests.natureOther
            ? formData.interests.natureOther
                .split(", ")
                .filter((item) => item.trim())
            : []),
        ],
      };

      const payload = {
        ...formData,
        membershipId: formData.membershipId, // keep same name if API uses this
        interests: cleanedInterests,
        profileInfo: {
          ...formData.profileInfo,
          dob: formData.profileInfo.dob
            ? new Date(formData.profileInfo.dob)
            : null,
        },
        membershipType: "standard",
        memberDesignation: member.memberDesignation?._id || null,
      };

      await updateMember(member._id, payload);
      window.history.back();

      toast.success("Profile Updated Successfully");
    } catch (error) {
      if (error.response?.data?.details) {
      } else {
        alert(error?.response?.data?.message || "Failed to submit application");
      }
    }
  };

  const handleProfileInfoChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      profileInfo: {
        ...prev.profileInfo,
        [field]: value,
      },
    }));
  };

  const handleCommunicationChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      communication: {
        ...prev.communication,
        [field]: value,
      },
    }));
  };

  const handleSocialLinkChange = (index, value) => {
    const newSocialLinks = [...formData.communication.socialLinks];
    newSocialLinks[index] = value;
    setFormData((prev) => ({
      ...prev,
      communication: {
        ...prev.communication,
        socialLinks: newSocialLinks,
      },
    }));
  };

  const handleOrganizationChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      organization: {
        ...prev.organization,
        [field]: value,
      },
    }));
  };

  const handleWorkExperienceChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      workExperience: {
        ...prev.workExperience,
        [field]: value,
      },
    }));
  };

  const handleSpeciesInterestChange = (value, isChecked) => {
    setFormData((prev) => {
      let newSpecies;

      if (value === "Others") {
        if (isChecked) {
          newSpecies = [...prev.interests.speciesOfInterest, "Others"];
        } else {
          newSpecies = prev.interests.speciesOfInterest.filter(
            (item) => item !== "Others"
          );
          return {
            ...prev,
            interests: {
              ...prev.interests,
              speciesOfInterest: newSpecies,
              speciesOther: "",
            },
          };
        }
      } else {
        newSpecies = isChecked
          ? [...prev.interests.speciesOfInterest, value]
          : prev.interests.speciesOfInterest.filter((item) => item !== value);
      }

      return {
        ...prev,
        interests: {
          ...prev.interests,
          speciesOfInterest: newSpecies,
        },
      };
    });
  };

  const handleFieldOfWorkChange = (value, isChecked) => {
    setFormData((prev) => {
      let newFields;

      if (value === "Others") {
        if (isChecked) {
          newFields = [...prev.interests.fieldOfWork, "Others"];
        } else {
          newFields = prev.interests.fieldOfWork.filter(
            (item) => item !== "Others"
          );
          return {
            ...prev,
            interests: {
              ...prev.interests,
              fieldOfWork: newFields,
              fieldOther: "",
            },
          };
        }
      } else {
        newFields = isChecked
          ? [...prev.interests.fieldOfWork, value]
          : prev.interests.fieldOfWork.filter((item) => item !== value);
      }

      return {
        ...prev,
        interests: {
          ...prev.interests,
          fieldOfWork: newFields,
        },
      };
    });
  };

  const handleNatureOfWorkChange = (value, isChecked) => {
    setFormData((prev) => {
      let newNature;

      if (value === "Others") {
        if (isChecked) {
          newNature = [...prev.interests.natureOfWork, "Others"];
        } else {
          newNature = prev.interests.natureOfWork.filter(
            (item) => item !== "Others"
          );
          return {
            ...prev,
            interests: {
              ...prev.interests,
              natureOfWork: newNature,
              natureOther: "",
            },
          };
        }
      } else {
        newNature = isChecked
          ? [...prev.interests.natureOfWork, value]
          : prev.interests.natureOfWork.filter((item) => item !== value);
      }

      return {
        ...prev,
        interests: {
          ...prev.interests,
          natureOfWork: newNature,
        },
      };
    });
  };

  const handleInterestsTextChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      interests: {
        ...prev.interests,
        [field]: value,
      },
    }));
  };

  const handleEducationDetailsChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      educationDetails: value,
    }));
  };

  const [openNews, setOpenNews] = useState(false);

  const [auth, setAuth] = useState(() => {
    const token = Cookies.get("token");
    const role = Cookies.get("role");
    const email = Cookies.get("email");
    return { token, role, email };
  });
  const isAuthenticated = !!(auth?.token && auth?.role && auth?.email);

  const scrollToTop = () => {
    if (typeof window != "undefined") {
      window.scrollTo(0, 0);
    }
  };

  function truncateWords(html, count = 20) {
    if (!html) return "";

    const text = html
      .replace(/<style[\s\S]*?<\/style>|<script[\s\S]*?<\/script>/gi, "")
      .replace(/<[^>]+>/g, " ") // strip all tags
      .replace(/&nbsp;|&#160;/gi, " ") // handle space entities
      .replace(/&amp;/gi, "&") // minimal decode
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/\s+/g, " ")
      .trim();

    const words = text.split(" ");
    const clipped = words
      .slice(0, Math.max(1, Math.min(count, words.length)))
      .join(" ");
    return clipped + (words.length > count ? "…" : "");
  }

  return (
    <>
      <main>
        <Breadcrumb title="Member's Dashboard" />
        <div className="it-teacher-details-area pt-50 pb-50">
          <div className="container">
            <div className="it-teacher-details-wrap">
              <Tabs>
                <div className="row">
                  <div className="col-xl-3 col-lg-3">
                    <div className="it-teacher-details-left">
                      <div className="it-teacher-details-left-thumb ">
                        <img
                          className="rounded-5 h-[300px] object-cover"
                          src={formData.profileInfo.photo || Men}
                          alt="Member"
                          onError={(e) => {
                            e.target.src = Men;
                          }}
                        />
                      </div>
                      <div className="it-teacher-details-left-social text-center pb-0">
                        <h5 style={{ color: "#704fe6" }}>{fullName}</h5>
                        <h6>{member?.membershipId || "N/A"}</h6>
                        <p>{member?.memberDesignation?.name || "N/A"}</p>
                      </div>

                      <TabList
                        style={{ listStyle: "none" }}
                        className="member-tab "
                        id="nav-tab"
                        role="tablist"
                      >
                        <Tab>
                          <button
                            onClick={scrollToTop}
                            className="ed-btn-theme"
                          >
                            Profile
                          </button>
                        </Tab>
                        <Tab>
                          <button
                            onClick={scrollToTop}
                            className="ed-btn-theme"
                          >
                            News
                          </button>
                        </Tab>
                        <Tab>
                          <button
                            onClick={scrollToTop}
                            className="ed-btn-theme"
                          >
                            View ID-CARD{" "}
                          </button>
                        </Tab>
                        <Tab>
                          <button
                            onClick={scrollToTop}
                            className="ed-btn-theme"
                          >
                            View Promo Image{" "}
                          </button>
                        </Tab>
                        <Tab>
                          <button
                            onClick={scrollToTop}
                            className="ed-btn-theme"
                          >
                            Change Password{" "}
                          </button>
                        </Tab>
                        <Tab>
                          <button
                            onClick={scrollToTop}
                            className="ed-btn-theme"
                          >
                            Edit Profile{" "}
                          </button>
                        </Tab>
                        <button onClick={logout} className="ed-btn-theme">
                          <a href="/home">Logout</a>
                        </button>
                      </TabList>
                    </div>
                  </div>

                  <div className="col-xl-9 col-lg-9">
                    <TabPanel>
                      <div className="it-teacher-details-right">
                        <div className="it-teacher-details-right-content">
                          <h5 className="mb-20" style={{ color: "#0b72ba" }}>
                            Personal Information
                          </h5>
                          <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-4">
                              <div className="it-teacher-details-left-info mb-0">
                                <ul>
                                  {firstHalf.map((item, index) =>
                                    item.content &&
                                    typeof item.content === "string" &&
                                    item.content !== "NA" ? (
                                      <li key={index}>
                                        <i
                                          className={item.icon}
                                          style={{ color: "#0e2a46" }}
                                        ></i>
                                        {item.content.startsWith("http") ? (
                                          <a
                                            href={item.content}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {item.content}
                                          </a>
                                        ) : (
                                          <a>{item.content}</a>
                                        )}
                                      </li>
                                    ) : null
                                  )}
                                </ul>
                              </div>
                            </div>

                            <div className="col-xl-6 col-lg-6 col-md-6">
                              <div className="it-teacher-details-left-info">
                                <ul>
                                  {secondHalf.map((item, index) =>
                                    item.content &&
                                    typeof item.content === "string" &&
                                    item.content !== "NA" ? (
                                      <li key={index}>
                                        <i
                                          className={item.icon}
                                          style={{ color: "#0e2a46" }}
                                        ></i>
                                        {item.content.startsWith("http") ||
                                        item.link ? (
                                          <a
                                            href={item.link || item.content}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {item.content}
                                          </a>
                                        ) : (
                                          <a>{item.content}</a>
                                        )}
                                      </li>
                                    ) : null
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="it-teacher-details-right-content mb-4">
                          <h5 className="mb-5 text-xl font-semibold text-[#0b72ba]">
                            Organizational Details
                          </h5>
                          <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
                            <div className="flex flex-col items-center md:flex-row md:items-center md:space-x-6">
                              <div className="mb-4 flex-shrink-0 md:mb-0">
                                <img
                                  className="h-48 w-48 rounded-full object-cover shadow-md"
                                  src={
                                    formData.organization.companyLogo || defualt
                                  }
                                  alt="Organization"
                                  onError={(e) => {
                                    e.target.src = defualt;
                                  }}
                                />
                              </div>

                              <div className="w-full space-y-3">
                                {organizationInfo.map((item, index) => (
                                  <div
                                    key={index}
                                    className="flex items-baseline"
                                  >
                                    <div className="flex-shrink-0 pt-1">
                                      {item.label === "Name" && (
                                        <i className="fas fa-building mr-3 text-gray-500"></i>
                                      )}
                                      {item.label === "Type" && (
                                        <i className="fas fa-briefcase mr-3 text-gray-500"></i>
                                      )}
                                      {item.label === "Address" && (
                                        <i className="fas fa-map-marker-alt mr-3 text-gray-500"></i>
                                      )}
                                      {item.label === "Phone" && (
                                        <i className="fas fa-phone-alt mr-3 text-gray-500"></i>
                                      )}
                                      {item.label === "Email" && (
                                        <i className="fas fa-envelope mr-3 text-gray-500"></i>
                                      )}
                                      {item.label === "About Company" && (
                                        <i className="fas fa-info-circle mr-3 text-gray-500"></i>
                                      )}
                                    </div>
                                    <div className="min-w-0 flex-1">
                                      <p className="text-sm font-medium text-gray-900">
                                        {item.label}
                                      </p>
                                      <p className="text-sm text-gray-600">
                                        {item.content || (
                                          <span className="italic text-gray-400">
                                            Not provided
                                          </span>
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="it-teacher-details-right-content mb-40">
                          <h5 className="mb-20" style={{ color: "#0b72ba" }}>
                            Education Information & Area Of Interest
                          </h5>
                          <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                              <div className="postbox__details-tag mb-2">
                                <>
                                  <span>Species of Interest</span>
                                  <div>
                                    {educationinformationareaofinteres[0].speciesOfInterest.map(
                                      (tag, index) => (
                                        <a href="#" key={index}>
                                          {tag}
                                        </a>
                                      )
                                    )}
                                  </div>
                                </>
                              </div>
                              <div className="postbox__details-tag mb-2">
                                <>
                                  <span>Field of Work</span>
                                  <div>
                                    {educationinformationareaofinteres[0].fieldOfWork.map(
                                      (tag, index) => (
                                        <a href="#" key={index}>
                                          {tag}
                                        </a>
                                      )
                                    )}
                                  </div>
                                </>
                              </div>
                              <div className="postbox__details-tag mb-2">
                                <>
                                  <span>Nature of Work</span>
                                  <div>
                                    {educationinformationareaofinteres[0].natureOfWork.map(
                                      (tag, index) => (
                                        <a href="#" key={index}>
                                          {tag}
                                        </a>
                                      )
                                    )}
                                  </div>
                                </>
                              </div>
                              <div className="postbox__details-tag mb-2">
                                <span>Education Details</span>
                                <p>{formData.educationDetails}</p>
                              </div>
                              <div className="postbox__details-tag mb-2">
                                <span>Work Experience in Aquaculture</span>
                                <div className="it-progress-bar-item">
                                  <label className="mb-10">
                                    {formData.workExperience.experienceYears ||
                                      0}
                                  </label>
                                  <SingleProgress
                                    progress={
                                      formData.workExperience.experienceYears ||
                                      0
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {rolesData.length > 0 && (
                          <div className="it-teacher-details-right-content">
                            <h5 className="mb-20" style={{ color: "#0b72ba" }}>
                              Leadership Roles in SAP
                            </h5>
                            <div className="row">
                              <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="overflow-x-auto">
                                  <table
                                    className="table-bordered"
                                    style={{ width: "100%" }}
                                  >
                                    <thead
                                      style={{ backgroundColor: "#17254e" }}
                                    >
                                      <tr>
                                        <th
                                          style={{
                                            padding: "10px",
                                            textAlign: "left",
                                            color: "white",
                                          }}
                                        >
                                          S.NO
                                        </th>
                                        <th
                                          style={{
                                            padding: "10px",
                                            textAlign: "left",
                                            color: "white",
                                          }}
                                        >
                                          ROLE
                                        </th>
                                        <th
                                          style={{
                                            padding: "10px",
                                            textAlign: "left",
                                            color: "white",
                                          }}
                                        >
                                          PERIOD
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {rolesData.length > 0 ? (
                                        <>
                                          {rolesData.map((item, index) => (
                                            <tr key={item.sno}>
                                              <td style={{ padding: "10px" }}>
                                                {item.sno}
                                              </td>
                                              <td style={{ padding: "10px" }}>
                                                {item.role}
                                              </td>
                                              <td style={{ padding: "10px" }}>
                                                {item.period}
                                              </td>
                                            </tr>
                                          ))}
                                        </>
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={3}
                                            style={{
                                              padding: "10px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Currently not having any leadership
                                            role
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </TabPanel>

                    <TabPanel>
                      <div className="it-teacher-details-right">
                        <div className="flex justify-between items-center w-full mb-4">
                          <h3 style={{ color: "#704fe6" }}>News</h3>
                          <button
                            className="bg-[#704FE6] text-white px-4 py-[8px] rounded-lg"
                            onClick={() => setOpenNews(true)}
                          >
                            Add news
                          </button>
                        </div>
                        <div>
                          {memberNews && memberNews.length > 0 ? (
                            <div className="grid grid-cols-2 gap-4">
                              {memberNews.map((item, idx) => (
                                <div
                                  key={item._id}
                                  className="wow animate__fadeInUp"
                                  data-wow-duration=".9s"
                                  data-wow-delay={`.${(idx % 3) + 3}s`}
                                >
                                  <div className="position-relative">
                                    {isAuthenticated &&
                                      item.visibility === "private" && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: "15px",
                                            right: "15px",
                                            zIndex: 10,
                                            background:
                                              "linear-gradient(45deg, #dc3545, #e85a6b)",
                                            color: "white",
                                            padding: "6px 12px",
                                            borderRadius: "20px",
                                            fontSize: "11px",
                                            fontWeight: "600",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.5px",
                                            boxShadow:
                                              "0 2px 8px rgba(220, 53, 69, 0.3)",
                                            border: "2px solid white",
                                          }}
                                        >
                                          <i className="fa-solid fa-lock me-1"></i>
                                          Private
                                        </div>
                                      )}
                                    {item.visibility === "public" && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "15px",
                                          right: "15px",
                                          zIndex: 10,
                                          background:
                                            "linear-gradient(45deg, #28a745, #34ce57)",
                                          color: "white",
                                          padding: "6px 12px",
                                          borderRadius: "20px",
                                          fontSize: "11px",
                                          fontWeight: "600",
                                          textTransform: "uppercase",
                                          letterSpacing: "0.5px",
                                          boxShadow:
                                            "0 2px 8px rgba(40, 167, 69, 0.3)",
                                          border: "2px solid white",
                                        }}
                                      >
                                        <i className="fa-solid fa-globe me-1"></i>
                                        Public
                                      </div>
                                    )}

                                    <SingleBlog
                                      isFromMember={true}
                                      heading={item.title}
                                      title={truncateWords(
                                        item.description,
                                        40
                                      )}
                                      publishedDate={new Date(
                                        item.date
                                      ).toLocaleDateString("en-IN", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })}
                                      btnClass="ed-btn-blog"
                                      hasArrow
                                      image={item.imageUrl?.[0]}
                                      _id={item._id}
                                      status={item.status}
                                      type="news"
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p className="text-center text-gray-500 mt-4">
                              No news available at the moment.
                            </p>
                          )}
                        </div>
                      </div>
                    </TabPanel>

                    <TabPanel>
                      <div className="it-teacher-details-right">
                        <h3
                          style={{ color: "#704fe6" }}
                          className="text-center"
                        >
                          Membership ID Card
                        </h3>
                        <div className="row text-center">
                          <div className="flex flex-col col-xl-12 col-lg-12 ">
                            <div
                              ref={cardRef}
                              style={{
                                backgroundColor: "#ffffff", // white border background
                                padding: "15px", // white space around ID
                                borderRadius: "12px",
                                display: "inline-block",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                              }}
                            >
                              <div
                                ref={cardRef}
                                style={{
                                  fontFamily: "Verdana, sans-serif",
                                  borderRadius: "8px",
                                  width: "300px",
                                  margin: "0 auto",
                                  paddingTop: "5px",
                                  position: "relative",
                                  boxSizing: "border-box",
                                }}
                              >
                                {/* ==== TOP HOOK AREA ==== */}
                                <div
                                  style={{
                                    backgroundColor: "black",
                                    width: "70px",
                                    height: "15px",
                                    borderRadius: "5px 5px 0 0",
                                    margin: "0 auto",
                                    position: "relative",
                                    border: "5px",
                                  }}
                                >
                                  <div
                                    style={{
                                      backgroundColor: "white",
                                      width: "47px",
                                      height: "6px",
                                      borderRadius: "4px",
                                      position: "absolute",
                                      top: "6px",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                    }}
                                  ></div>
                                </div>

                                {/* ==== CARD BODY ==== */}
                                <div
                                  style={{
                                    backgroundColor: "#fff",
                                    borderRadius: "10px",
                                    textAlign: "center",
                                    overflow: "hidden",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    height: "420px", // extra height helps footer spacing
                                    border: "5px solid #1f1f1f", // ✅ proper solid border instead of box-shadow
                                    boxSizing: "border-box",
                                  }}
                                >
                                  {/* HEADER */}
                                  <div
                                    style={{
                                      backgroundColor: "#eaf5fd",
                                      padding: "10px 0",
                                      borderBottom: "1px solid #d4e6f1",
                                    }}
                                  >
                                    <img
                                      src={Logo}
                                      alt="Logo"
                                      style={{
                                        width: "200px",
                                        display: "block",
                                        margin: "0 auto",
                                      }}
                                    />
                                  </div>

                                  {/* MEMBER INFO */}
                                  <div>
                                    <img
                                      src={formData.profileInfo.photo || Men}
                                      alt="Member"
                                      onError={(e) => (e.target.src = Men)}
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        borderRadius: "10px",
                                        objectFit: "cover",
                                        display: "block",
                                        margin: "15px auto 10px auto",
                                      }}
                                    />
                                    <h2
                                      style={{
                                        fontSize: "15px",
                                        margin: "5px 0",
                                        color: "#000",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {fullName}
                                    </h2>
                                    <h3
                                      style={{
                                        fontSize: "12px",
                                        margin: "2px 0",
                                        fontWeight: "400",
                                        color: "#000",
                                      }}
                                    >
                                      Member
                                    </h3>
                                    <h3
                                      style={{
                                        fontSize: "12px",
                                        margin: "2px 0 15px 0",
                                        fontWeight: "400",
                                        color: "#000",
                                      }}
                                    >
                                      {member?.membershipId || "N/A"}
                                    </h3>
                                  </div>

                                  {/* FOOTER */}
                                  <div
                                    style={{
                                      backgroundColor: "#eaf5fd",
                                      padding: "10px 0 14px 0",
                                      borderTop: "1px solid #d4e6f1",
                                      borderBottomLeftRadius: "10px",
                                      borderBottomRightRadius: "10px",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                      lineHeight: "1.4",
                                    }}
                                  >
                                    <p
                                      style={{
                                        fontSize: "9px",
                                        margin: "2px 0",
                                      }}
                                    >
                                      {formData.communication.address}
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "9px",
                                        margin: "2px 0",
                                      }}
                                    >
                                      E-mail: {formData.communication.email}
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "9px",
                                        margin: "2px 0",
                                      }}
                                    >
                                      Phone: +91 {formData.communication.mobile}
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "9px",
                                        margin: "2px 0",
                                      }}
                                    >
                                      Website: www.societyofaquacultureprofessionals.org
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-col items-center justify-center">
                              <a
                                onClick={downloadPDF}
                                className="w-[300px] ed-btn-theme text-white mt-20"
                                style={{
                                  textDecoration: "none",
                                  cursor: "pointer",
                                  display: "inline-block",
                                  marginTop: "20px",
                                }}
                              >
                                Download ID Card
                                <i>
                                  <RightArrow />
                                </i>
                              </a>
                              <a
                                onClick={downloadImage}
                                className="w-[300px] ed-btn-theme text-white mt-2"
                                style={{
                                  textDecoration: "none",
                                  cursor: "pointer",
                                  display: "inline-block",
                                  marginTop: "10px",
                                }}
                              >
                                Download Image
                                <i>
                                  <RightArrow />
                                </i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>

                    <TabPanel>
                      <div className="it-teacher-details-right">
                        <div className="row align-items-center mb-20">
                          <div className="col-12 col-md-12 text-center">
                            <img
                              className="img-fluid rounded-5"
                              style={{
                                width: "300px",
                                height: "300px",
                                objectFit: "cover",
                              }}
                              src={formData.profileInfo.photo || Men}
                              alt="Profile"
                              onError={(e) => {
                                e.target.src = Men;
                              }}
                            />
                          </div>
                          <div className="col-12 col-md-12 text-center mt-40">
                            <a
                              href={formData.profileInfo.photo || Men}
                              download="profile-dp.jpg"
                              className="ed-btn-theme text-white"
                              style={{ textDecoration: "none" }}
                            >
                              Download Profile Dp
                              <i>
                                <RightArrow />
                              </i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </TabPanel>

                    <TabPanel>
                      <ChangePasswordTabPanel memberId={member?._id} />
                    </TabPanel>

                    <TabPanel>
                      <div className="it-teacher-details-right">
                        <form onSubmit={handleSubmit}>
                          <div className="it-student-regiform">
                            <h4 className="it-student-regiform-title">
                              Profile information
                            </h4>
                            <div className="it-student-regiform-wrap">
                              <div className="row">
                                <div className="col-xl-2">
                                  <div className="it-student-regiform-item">
                                    <label>Title</label>
                                    <div className="postbox__select">
                                      <select
                                        style={style}
                                        defaultValue={
                                          formData.profileInfo.title
                                        }
                                        value={formData.profileInfo.title}
                                        onChange={(e) =>
                                          handleProfileInfoChange(
                                            "title",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option style={optionStyle} value="Mr">
                                          Mr
                                        </option>
                                        <option style={optionStyle} value="Ms">
                                          Ms
                                        </option>
                                        <option style={optionStyle} value="Dr">
                                          Dr
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-4">
                                  <div className="it-student-regiform-item">
                                    <label>First Name *</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.profileInfo.firstName
                                      }
                                      value={formData.profileInfo.firstName}
                                      onChange={(e) =>
                                        handleProfileInfoChange(
                                          "firstName",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-3">
                                  <div className="it-student-regiform-item">
                                    <label>Middle Name</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.profileInfo.middleName
                                      }
                                      value={formData.profileInfo.middleName}
                                      onChange={(e) =>
                                        handleProfileInfoChange(
                                          "middleName",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-3">
                                  <div className="it-student-regiform-item">
                                    <label>Last Name *</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.profileInfo.lastName
                                      }
                                      value={formData.profileInfo.lastName}
                                      onChange={(e) =>
                                        handleProfileInfoChange(
                                          "lastName",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="col-xl-4">
                                  <div className="it-student-regiform-item">
                                    <label>Membership ID</label>
                                    <input
                                      type="text"
                                      value={formData.membershipId}
                                      onChange={(e) =>
                                        setFormData((prev) => ({
                                          ...prev,
                                          membershipId: e.target.value,
                                        }))
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Date of Birth *</label>
                                    <input
                                      type="date"
                                      defaultValue={
                                        formData.profileInfo.dob?.split("T")[0]
                                      }
                                      value={
                                        formData.profileInfo.dob?.split(
                                          "T"
                                        )[0] || ""
                                      }
                                      onChange={(e) =>
                                        handleProfileInfoChange(
                                          "dob",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Gender *</label>
                                    <div className="postbox__select">
                                      <select
                                        style={style}
                                        defaultValue={
                                          formData.profileInfo.gender
                                        }
                                        value={formData.profileInfo.gender}
                                        onChange={(e) =>
                                          handleProfileInfoChange(
                                            "gender",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option
                                          style={optionStyle}
                                          value="Male"
                                        >
                                          Male
                                        </option>
                                        <option
                                          style={optionStyle}
                                          value="Female"
                                        >
                                          Female
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Photo *</label>
                                    <div className="postbox__resume-wrap mb-20 d-flex align-items-center flex-wrap">
                                      <div className="postbox__resume mr-20">
                                        <input
                                          id="fileOne"
                                          type="file"
                                          hidden
                                          ref={fileOneRef}
                                          accept="image/*"
                                          onChange={handleFileOneChange}
                                        />
                                        <label htmlFor="fileOne">
                                          <span className="text-white">
                                            Choose File
                                          </span>
                                        </label>
                                      </div>
                                      <div
                                        className="postbox__resume border-transparent text-black"
                                        style={{
                                          backgroundColor: "transparent",
                                        }}
                                      >
                                        <label htmlFor="fileOne">
                                          <span>{fileOne}</span>
                                        </label>
                                      </div>
                                    </div>
                                    {formData.profileInfo.photo &&
                                    formData.profileInfo.photo !== "" &&
                                    formData.profileInfo.photo !== "NA" ? (
                                      <div
                                        className="mb-2 position-relative"
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                        }}
                                      >
                                        <img
                                          src={formData.profileInfo.photo}
                                          alt="Preview"
                                          style={{
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            objectFit: "cover",
                                          }}
                                        />
                                        <button
                                          onClick={handleDeletePhoto}
                                          className="position-absolute top-0 end-0 bg-danger text-white border-0 rounded-circle"
                                          style={{
                                            width: "24px",
                                            height: "24px",
                                            transform: "translate(50%, -50%)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                          title="Remove photo"
                                        >
                                          <X size={12} />
                                        </button>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="it-student-regiform">
                            <h4 className="it-student-regiform-title">
                              Communication Details
                            </h4>

                            <div className="it-student-regiform-wrap">
                              <div className="row">
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Email ID</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.communication.email
                                      }
                                      value={formData.communication.email}
                                      onChange={(e) =>
                                        handleCommunicationChange(
                                          "email",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Telephone</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.communication.telephone
                                      }
                                      value={formData.communication.telephone}
                                      onChange={(e) =>
                                        handleCommunicationChange(
                                          "telephone",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>WhatsApp Number</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.communication.whatsapp
                                      }
                                      value={formData.communication.whatsapp}
                                      onChange={(e) =>
                                        handleCommunicationChange(
                                          "whatsapp",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Mobile *</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.communication.mobile
                                      }
                                      value={formData.communication.mobile}
                                      onChange={(e) =>
                                        handleCommunicationChange(
                                          "mobile",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Address *</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.communication.address
                                      }
                                      value={formData.communication.address}
                                      onChange={(e) =>
                                        handleCommunicationChange(
                                          "address",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>City*</label>
                                    <input
                                      type="text"
                                      defaultValue={formData.communication.city}
                                      value={formData.communication.city}
                                      onChange={(e) =>
                                        handleCommunicationChange(
                                          "city",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Zipcode*</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.communication.zipcode
                                      }
                                      value={formData.communication.zipcode}
                                      onChange={(e) =>
                                        handleCommunicationChange(
                                          "zipcode",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>country*</label>
                                    <div className="postbox__select">
                                      <select
                                        style={style}
                                        defaultValue={
                                          formData.communication.country
                                        }
                                        value={formData.communication.country}
                                        onChange={(e) =>
                                          handleCommunicationChange(
                                            "country",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value="">
                                          -- Select Country --
                                        </option>
                                        <option value="IN">India</option>
                                        <option value="AF">Afghanistan</option>
                                        <option value="AR">Argentina</option>
                                        <option value="AU">Australia</option>
                                        <option value="BD">Bangladesh</option>
                                        <option value="BR">Brazil</option>
                                        <option value="CA">Canada</option>
                                        <option value="CN">China</option>
                                        <option value="EG">Egypt</option>
                                        <option value="FR">France</option>
                                        <option value="DE">Germany</option>
                                        <option value="ID">Indonesia</option>
                                        <option value="IR">Iran</option>
                                        <option value="IQ">Iraq</option>
                                        <option value="IT">Italy</option>
                                        <option value="JP">Japan</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                {[0, 1, 2].map((index) => (
                                  <div className="col-xl-4" key={index}>
                                    <div className="it-student-regiform-item">
                                      <label>Website/Social Media</label>
                                      <input
                                        type="text"
                                        value={
                                          formData.communication.socialLinks[
                                            index
                                          ]
                                        }
                                        onChange={(e) =>
                                          handleSocialLinkChange(
                                            index,
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>

                          <div className="it-student-regiform">
                            <h4 className="it-student-regiform-title">
                              Organizational Details
                            </h4>

                            <div className="it-student-regiform-wrap">
                              <div className="row">
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Organization Name</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.organization.organizationName
                                      }
                                      value={
                                        formData.organization.organizationName
                                      }
                                      onChange={(e) =>
                                        handleOrganizationChange(
                                          "organizationName",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Organization Type</label>
                                    <div className="postbox__select">
                                      <select
                                        style={style}
                                        defaultValue={
                                          formData.organization.organizationType
                                        }
                                        value={
                                          formData.organization.organizationType
                                        }
                                        onChange={(e) =>
                                          handleOrganizationChange(
                                            "organizationType",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value="Private Enterprise">
                                          Private Enterprise
                                        </option>
                                        <option value="Educational Institution">
                                          Educational Institution
                                        </option>
                                        <option value="Research Organization">
                                          Research Organization
                                        </option>
                                        <option value="Government">
                                          Government
                                        </option>
                                        <option value="Others">Others</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Address</label>
                                    <textarea
                                      style={{
                                        border: "1px solid black",
                                        borderRadius: "10px",
                                        height: "180px",
                                      }}
                                      defaultValue={
                                        formData.organization
                                          .organizationAddress
                                      }
                                      value={
                                        formData.organization
                                          .organizationAddress
                                      }
                                      onChange={(e) =>
                                        handleOrganizationChange(
                                          "organizationAddress",
                                          e.target.value
                                        )
                                      }
                                    ></textarea>
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Phone</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.organization.organizationPhone
                                      }
                                      value={
                                        formData.organization.organizationPhone
                                      }
                                      onChange={(e) =>
                                        handleOrganizationChange(
                                          "organizationPhone",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  <div className="it-student-regiform-item">
                                    <label>Email</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.organization.organizationEmail
                                      }
                                      value={
                                        formData.organization.organizationEmail
                                      }
                                      onChange={(e) =>
                                        handleOrganizationChange(
                                          "organizationEmail",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-12">
                                  <div className="it-student-regiform-item">
                                    <label>About Company</label>
                                    <textarea
                                      style={{
                                        border: "1px solid black",
                                        borderRadius: "10px",
                                        height: "180px",
                                      }}
                                      defaultValue={
                                        formData.organization.aboutCompany
                                      }
                                      value={formData.organization.aboutCompany}
                                      onChange={(e) =>
                                        handleOrganizationChange(
                                          "aboutCompany",
                                          e.target.value
                                        )
                                      }
                                    ></textarea>
                                  </div>
                                </div>
                                <div className="col-xl-12">
                                  <div className="it-student-regiform-item">
                                    <label>Company Logo</label>
                                    <div className="postbox__resume-wrap mb-20 d-flex align-items-center flex-wrap">
                                      <div className="postbox__resume mr-20">
                                        <input
                                          id="fileTwo"
                                          type="file"
                                          ref={fileTwoRef}
                                          hidden
                                          accept="image/*"
                                          onChange={handleFileTwoChange}
                                        />
                                        <label htmlFor="fileTwo">
                                          <span className="text-white">
                                            Choose File
                                          </span>
                                        </label>
                                      </div>
                                      <div
                                        className="postbox__resume border-transparent text-black"
                                        style={{
                                          backgroundColor: "transparent",
                                        }}
                                      >
                                        <label htmlFor="fileTwo">
                                          <span>{fileTwo}</span>
                                        </label>
                                      </div>
                                    </div>
                                    {formData.organization.companyLogo !=
                                    "NA" ? (
                                      <div
                                        className="mb-2 position-relative"
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                        }}
                                      >
                                        <img
                                          src={
                                            formData.organization.companyLogo
                                          }
                                          alt="Company Logo Preview"
                                          style={{
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            objectFit: "cover",
                                          }}
                                        />
                                        <button
                                          onClick={handleDeleteLogo}
                                          className="position-absolute top-0 end-0 bg-danger text-white border-0 rounded-circle"
                                          style={{
                                            width: "24px",
                                            height: "24px",
                                            transform: "translate(50%, -50%)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                          title="Remove logo"
                                        >
                                          <X size={12} />
                                        </button>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="it-student-regiform">
                            <h4 className="it-student-regiform-title">
                              Work Experience
                            </h4>
                            <p>
                              Provide details such as organization name, your
                              job title and/or responsibilities, and number of
                              years and months in each job in the following.
                              Please start with your current position.
                            </p>
                            <h6>
                              Year of Start in Work Experience in Aquaculture
                            </h6>
                            <div className="it-student-regiform-wrap">
                              <div className="row">
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Years*</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.workExperience.experienceYears
                                      }
                                      value={
                                        formData.workExperience.experienceYears
                                      }
                                      onChange={(e) =>
                                        handleWorkExperienceChange(
                                          "experienceYears",
                                          parseInt(e.target.value) || 0
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-6">
                                  <div className="it-student-regiform-item">
                                    <label>Months (Optional)</label>
                                    <input
                                      type="text"
                                      defaultValue={
                                        formData.workExperience.experienceMonths
                                      }
                                      value={
                                        formData.workExperience.experienceMonths
                                      }
                                      onChange={(e) =>
                                        handleWorkExperienceChange(
                                          "experienceMonths",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="it-student-regiform">
                            <h4 className="it-student-regiform-title">
                              Species of Interest
                            </h4>
                            <p>
                              (Required Minimum one and maximum 3 areas can be
                              selected) *
                            </p>

                            <div className="it-student-regiform-wrap">
                              <div className="row">
                                <div className="col-xl-12">
                                  <div className="row">
                                    <div className="col-xl-6">
                                      <div className="it-signup-agree">
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value="Shrimp"
                                            id="shrimp"
                                            checked={formData.interests.speciesOfInterest.includes(
                                              "Shrimp"
                                            )}
                                            onChange={(e) =>
                                              handleSpeciesInterestChange(
                                                "Shrimp",
                                                e.target.checked
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="shrimp"
                                          >
                                            Shrimp
                                          </label>
                                        </div>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value="Warm Water Freshwater Fish"
                                            id="warmWater"
                                            checked={formData.interests.speciesOfInterest.includes(
                                              "Warm Water Freshwater Fish"
                                            )}
                                            onChange={(e) =>
                                              handleSpeciesInterestChange(
                                                "Warm Water Freshwater Fish",
                                                e.target.checked
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="warmWater"
                                          >
                                            Warm Water Freshwater Fish
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-xl-3">
                                      <div className="it-signup-agree">
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value="Coldwater Fish"
                                            id="coldWater"
                                            checked={formData.interests.speciesOfInterest.includes(
                                              "Coldwater Fish"
                                            )}
                                            onChange={(e) =>
                                              handleSpeciesInterestChange(
                                                "Coldwater Fish",
                                                e.target.checked
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="coldWater"
                                          >
                                            Coldwater Fish
                                          </label>
                                        </div>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value="Marine Fish"
                                            id="marineFish"
                                            checked={formData.interests.speciesOfInterest.includes(
                                              "Marine Fish"
                                            )}
                                            onChange={(e) =>
                                              handleSpeciesInterestChange(
                                                "Marine Fish",
                                                e.target.checked
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="marineFish"
                                          >
                                            Marine Fish
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-xl-3">
                                      <div className="it-instructor-wrap">
                                        <div className="it-signup-agree">
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value="Others"
                                              id="speciesOther"
                                              checked={formData.interests.speciesOfInterest.includes(
                                                "Others"
                                              )}
                                              onChange={(e) =>
                                                handleSpeciesInterestChange(
                                                  "Others",
                                                  e.target.checked
                                                )
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor="speciesOther"
                                            >
                                              Others
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-xl-6">
                                      <div className="it-student-regiform-item">
                                        <input
                                          type="text"
                                          placeholder="Others"
                                          value={
                                            formData.interests.speciesOther
                                          }
                                          onChange={(e) =>
                                            handleInterestsTextChange(
                                              "speciesOther",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            !formData.interests.speciesOfInterest.includes(
                                              "Others"
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="it-student-regiform">
                            <h4 className="it-student-regiform-title">
                              Field of Work
                            </h4>
                            <p>
                              (Required Minimum one and maximum 3 areas can be
                              selected) *
                            </p>

                            <div className="it-student-regiform-wrap">
                              <div className="row">
                                <div className="col-xl-12">
                                  <div className="row mb-20">
                                    <div className="col-xl-6">
                                      <div className="it-signup-agree">
                                        {[
                                          "Hatchery Sector",
                                          "Farm Sector",
                                          "Healthcare Sector",
                                          "Feed Sector",
                                          "Machinery Sector",
                                        ].map((field) => (
                                          <div
                                            className="form-check"
                                            key={field}
                                          >
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={field}
                                              id={field
                                                .toLowerCase()
                                                .replace(/\s+/g, "-")}
                                              checked={formData.interests.fieldOfWork.includes(
                                                field
                                              )}
                                              onChange={(e) =>
                                                handleFieldOfWorkChange(
                                                  field,
                                                  e.target.checked
                                                )
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={field
                                                .toLowerCase()
                                                .replace(/\s+/g, "-")}
                                            >
                                              {field}
                                            </label>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                    <div className="col-xl-6">
                                      <div className="it-signup-agree">
                                        {[
                                          "Government Sector",
                                          "Processing Sector",
                                          "Fish Farming & Allied Sector",
                                          "Markets, Certifications, Policy",
                                          "Media",
                                        ].map((field) => (
                                          <div
                                            className="form-check"
                                            key={field}
                                          >
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={field}
                                              id={field
                                                .toLowerCase()
                                                .replace(/\s+/g, "-")}
                                              checked={formData.interests.fieldOfWork.includes(
                                                field
                                              )}
                                              onChange={(e) =>
                                                handleFieldOfWorkChange(
                                                  field,
                                                  e.target.checked
                                                )
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={field
                                                .toLowerCase()
                                                .replace(/\s+/g, "-")}
                                            >
                                              {field}
                                            </label>
                                          </div>
                                        ))}
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value="Others"
                                            id="fieldOther"
                                            checked={formData.interests.fieldOfWork.includes(
                                              "Others"
                                            )}
                                            onChange={(e) =>
                                              handleFieldOfWorkChange(
                                                "Others",
                                                e.target.checked
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="fieldOther"
                                          >
                                            Others
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-xl-6">
                                      <div className="it-student-regiform-item">
                                        <input
                                          type="text"
                                          placeholder="Others"
                                          value={formData.interests.fieldOther}
                                          onChange={(e) =>
                                            handleInterestsTextChange(
                                              "fieldOther",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            !formData.interests.fieldOfWork.includes(
                                              "Others"
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="it-student-regiform">
                            <h4 className="it-student-regiform-title">
                              Nature of Work
                            </h4>
                            <p>
                              (Required Minimum one and maximum 3 areas can be
                              selected) *
                            </p>

                            <div className="it-student-regiform-wrap">
                              <div className="row">
                                <div className="col-xl-12">
                                  <div className="row">
                                    <div className="col-xl-6">
                                      <div className="it-signup-agree">
                                        {[
                                          "Teaching",
                                          "Research",
                                          "Production",
                                        ].map((nature) => (
                                          <div
                                            className="form-check"
                                            key={nature}
                                          >
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={nature}
                                              id={nature.toLowerCase()}
                                              checked={formData.interests.natureOfWork.includes(
                                                nature
                                              )}
                                              onChange={(e) =>
                                                handleNatureOfWorkChange(
                                                  nature,
                                                  e.target.checked
                                                )
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={nature.toLowerCase()}
                                            >
                                              {nature}
                                            </label>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                    <div className="col-xl-3">
                                      <div className="it-signup-agree">
                                        {["Management", "Policy"].map(
                                          (nature) => (
                                            <div
                                              className="form-check"
                                              key={nature}
                                            >
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                value={nature}
                                                id={nature.toLowerCase()}
                                                checked={formData.interests.natureOfWork.includes(
                                                  nature
                                                )}
                                                onChange={(e) =>
                                                  handleNatureOfWorkChange(
                                                    nature,
                                                    e.target.checked
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor={nature.toLowerCase()}
                                              >
                                                {nature}
                                              </label>
                                            </div>
                                          )
                                        )}
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value="Others"
                                            id="natureOther"
                                            checked={formData.interests.natureOfWork.includes(
                                              "Others"
                                            )}
                                            onChange={(e) =>
                                              handleNatureOfWorkChange(
                                                "Others",
                                                e.target.checked
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="natureOther"
                                          >
                                            Others
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-xl-6">
                                      <div className="it-student-regiform-item">
                                        <input
                                          type="text"
                                          placeholder="Others"
                                          value={formData.interests.natureOther}
                                          onChange={(e) =>
                                            handleInterestsTextChange(
                                              "natureOther",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            !formData.interests.natureOfWork.includes(
                                              "Others"
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="it-student-regiform">
                            <h4 className="it-student-regiform-title">
                              Education Details
                            </h4>

                            <div className="it-student-regiform-wrap">
                              <div className="row">
                                <div className="col-xl-12">
                                  <div className="it-student-regiform-item">
                                    <label>Education Details</label>
                                    <textarea
                                      style={{
                                        border: "1px solid black",
                                        borderRadius: "10px",
                                        height: "180px",
                                      }}
                                      value={formData.educationDetails}
                                      onChange={(e) =>
                                        handleEducationDetailsChange(
                                          e.target.value
                                        )
                                      }
                                      defaultValue={formData.educationDetails}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="it-student-regiform">
                            <div className="it-student-regiform-wrap">
                              <div className="it-student-regiform-btn">
                                <button type="submit" className="ed-btn-theme">
                                  <span>
                                    Save Profile
                                    <i>
                                      <RightArrow />
                                    </i>
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </TabPanel>
                  </div>
                </div>
              </Tabs>
            </div>
          </div>
        </div>
      </main>

      {openNews && (
        <NewsFormPopup
          isOpen={openNews}
          onClose={() => setOpenNews(false)}
          shouldRefetch={refetch}
        />
      )}
    </>
  );
};

export default MemberProfileMain;
